import { configureStore } from '@reduxjs/toolkit';
import game from './game/slice';
import obstacles from './obstacles/slice';
import { useDispatch } from 'react-redux';

const store = configureStore({
  reducer: { game, obstacles },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export default store;
